import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { FileUploader } from 'ng2-file-upload';

import { saveAs as importedSaveAs } from "file-saver";

import { environment } from './../../../environments/environment';

import { CopertinarioService } from './../../services/copertinario.service';

import { AppComponent } from './../../app.component';

const JRXML_NAME_PREFIX = 'copertinario';
const JRXML_FONT_NAME = 'DejaVu Sans';


@Component({
  selector: 'app-copertinario',
  templateUrl: './copertinario.component.html',
  styleUrls: ['./copertinario.component.css'],
  providers: [CopertinarioService]
})
export class CopertinarioComponent implements OnInit {
  wmodel: any = {};
  loading: boolean;
  printing: boolean;
  files: any;
  urlPortale: string;

  public uploaderEans: FileUploader = new FileUploader({ url: environment.server.url + '/copertinario/uploadEans' });

  public uploaderCover: FileUploader = new FileUploader({ url: environment.server.url + '/copertinario/uploadCover' });

  @ViewChild('inputFile') fileInput: ElementRef;

  constructor(
    private service: CopertinarioService,
    public parent: AppComponent) {
    this.urlPortale = environment.urlPortale;
  }

  ngOnInit() {
    this.loading = true;

    setTimeout(() => {
      this.service.readCopertinario().subscribe(result => {
        console.log(result);
        if (result.success && result.copertinario) {
          this.wmodel = result.copertinario;
          this.wmodel.jrxmlName = '?';
          this.wmodel.fontName = JRXML_FONT_NAME;
          // this.wmodel.imgHeader = environment.copertinario.media + result.copertinario.imageName;
          this.wmodel.imgHeader = result.copertinario.imgHeader;
          this._setJrxmlName(result.copertinario.eans);
        }
        this.loading = false;
      })
    }, 500)

    this.uploaderEans.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      let wo = JSON.parse(response);
      console.log(item._file.name, wo.success);
      console.log(wo);

      if (wo.success) {
        this.wmodel.eans = wo.copertinario.eans;
        this._setJrxmlName(wo.copertinario.eans);
      } else {

      }
    }

    this.uploaderCover.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      let wo = JSON.parse(response);
      console.log(item._file.name, wo.success);
      console.log(wo);

      if (wo.success) {
        this.wmodel.imgHeader = environment.copertinario.media + wo.cover.filename;

      } else {

      }
    }
  }

  _setJrxmlName(weans) {
    console.log('_setJrxmlName', weans);
    if (weans) {
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }

      switch (weans.length) {
        case 1:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '1';
          break;
        case 2:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '11';
          break;
        case 3:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '21';
          break;
        case 4:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '22';
          break;
        case 5:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '32';
          break;
        case 6:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '33';
          break;
        case 7:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '331';
          break;
        case 8:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '332';
          break;
        case 9:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '333';
          break;
        case 12:
          this.wmodel.jrxmlName = JRXML_NAME_PREFIX + '444';
          break;
      }
    }
  }

  uploadEans(): void {
    let fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      console.log(fileToUpload)
      this.service.uploadEans(fileToUpload)
        .subscribe(
        result => {
          console.log(result)
        },
        error => {
          console.log(error)
        });
    }
  }

  createPDFCopertinario() {
    this.printing = true;
    this.parent.addToast('', 'elaborazione pdf', ((wid) => {
      this.service.createPDFCopertinario(this.wmodel).subscribe(res => {
        console.log(res)
        // importedSaveAs(res.blob(), 'aaaa.pdf');
        let hwcd = res.headers.get('content-disposition');
        let filename = hwcd.split('filename=')[1].replace(new RegExp(/"/g), '');
        console.log(hwcd)
        console.log(filename)
        importedSaveAs(res.blob(), filename);



        this.service.persist(this.wmodel).subscribe((res) => {
          console.log(res)
          this.parent.clearToast(wid);
          this.printing = false;

        })
        // this.persist()

      })
    }).bind(this))
  }


  // persist() {
  //   let that = this;
  //   that.loading = true;
  //   that.parent.addToast('', 'salvataggio in corso...', ((wid) => {
  //     setTimeout(function() {
  //       that.service.persist(that.wmodel).subscribe((res) => {
  //         console.log(res)
  //         that.parent.clearToast(wid);
  //         that.loading = false;
  //         that.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
  //       })
  //     }, 2000);
  //   }))
  // }

  getTitle(): string {
    return "copertinario";
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/copertinario/copertinario.component.ts